import React from 'react';
import type { AssetRef } from '../../types/place';

import AudioPlayer from '../players/AudioPlayer'

interface AudioWidgetProps {
    audio: AssetRef | null;
    name?: string;
}

const AudioWidget: React.FC<AudioWidgetProps> = ({audio, name}) => {

    return (
        <div>
            {audio && <AudioPlayer audio={audio.id} name={name} />}
        </div>
    );
};

export default AudioWidget;
